const UpcomingModalContent = ({ daysRemaining, promotionDescription }) => {
  return (
    <>
      <h4>{daysRemaining} days remaining</h4>

      <div>
        <p>{promotionDescription}</p>
      </div>
    </>
  );
};

export default UpcomingModalContent;
